import * as React from 'react';
import { IResizableColumnProps, IColumnProps } from './column-props';
import { Column } from './column';
import { makeMoveable, MoveableHandlerArguments } from '../../moveable';
import { IResizableGridContext, IResizableConfig } from '../grid-props';

const ResizableColumnBase = makeMoveable<IResizableGridContext, IColumnProps>(Column, ref => ({ elementRef: ref }));

export function ResizableColumn(props: IResizableColumnProps) {
    const { initialColumnSize = '1', resizableConfig, children, ...columnProps } = props;

    const [columnSize, setColumnSize] = React.useState(initialColumnSize);

    const _onResize = React.useCallback(({ width, context }: MoveableHandlerArguments<'onResize', IResizableGridContext>) => {
        const newColumnSize = Math.max(Math.round(width / context.unitSize), 1).toString();
        setColumnSize(newColumnSize);
    }, [setColumnSize]);

    const moveableConfigs = React.useMemo((): IResizableConfig => ({
        resizable: true,
        origin: false,
        onResize: _onResize,
        renderDirections: ['e'],
        ...resizableConfig
    }), [resizableConfig, _onResize]);

    return (
        <ResizableColumnBase columnSize={columnSize} moveable={moveableConfigs} {...columnProps}>
            {children}
        </ResizableColumnBase>
    );
}
